var map = {
	"./navigation.de-CH.json": 1082,
	"./navigation.de-DE.json": 1083,
	"./navigation.en-CA.json": 1084,
	"./navigation.en-GB.json": 1085,
	"./navigation.en-IN.json": 1086,
	"./navigation.en-ME.json": 1087,
	"./navigation.en-US.json": 1088,
	"./navigation.es-EM.json": 1089,
	"./navigation.es-ES.json": 1090,
	"./navigation.fr-BE.json": 1091,
	"./navigation.fr-CA.json": 1092,
	"./navigation.fr-CH.json": 1093,
	"./navigation.nl-BE.json": 1094,
	"./navigation.nl-NL.json": 1095,
	"./navigation.pl-PL.json": 1096,
	"./navigation.pt-BR.json": 1097
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1081;